var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"button",class:((_vm.className ? _vm.className:'') + " " + (_vm.spinner ? 'loading':'') + "  " + _vm.variant + " " + _vm.color),attrs:{"type":_vm.type}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }